// @ts-nocheck
import { faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef } from "react";
import Moment from "react-moment";
import useFetch from "../../../ApiClient/GetApi";
import { useNavigate } from "react-router-dom";

export default function WayBillModal() {
  // const [waybill, setWaybill] = useState(true);
  const contentRef = useRef(null);
  const navigate = useNavigate();

  const { data } = useFetch(
    `booking/booking_detail/${localStorage.getItem("orderId")}`
  );

  const closeWaybill = () => {
    // const content = contentRef.current;
    // const options = {
    //   margin: 10,
    //   filename: "document.pdf",
    //   image: { type: "jpeg", quality: 0.98 },
    // };

    // html2pdf()
    //   .from(content)
    //   .set(options)
    //   .outputPdf()
    //   .then((pdf) => {
    //     const blob = new Blob([pdf], { type: "application/pdf" });
    //     const url = URL.createObjectURL(blob);
    //     const a = document.createElement("a");
    //     a.href = url;
    //     a.download = options.filename;
    //     a.click();

    //     // Move setWaybill(false) here
    //     setWaybill(false);
    //   })
    //   .catch((error) => {
    //     console.error("Error generating PDF:", error);
    //     // Handle the error if needed
    //   });

    navigate("/order_details");
  };

  const tdStyle = "font-normal text-base text-black text-opacity-60 py-2";
  const liStyle =
    "border border-black font-normal sm:text-base text-xs text-black py-2 sm:px-3 px-1 whitespace-nowrap";
  return (
    <div
      className="absolute w-full print:h-full top-0 left-0 bg-black bg-opacity-60 z-[60] space-y-10 print:space-y-60"
      id="component-to-print"
      ref={contentRef}
    >
      {data?.data?.order?.Packages?.map((pack, index) => (
        <div className="relative xl:w-4/6 lg:w-4/5 w-[96%] left-[50%] -translate-x-[50%] bg-white border border-black waybill">
          <div
            className="border-2 border-black border-opacity-60 float-right 
                  rounded-fullest cursor-pointer sm:text-black h-6 w-6 inline-flex 
                  justify-center items-center mr-3 mt-3 print:hidden"
          >
            <FontAwesomeIcon
              icon={faMultiply}
              className="text-black text-opacity-60"
              onClick={closeWaybill}
            />
          </div>
          <div className="my-16 sm:px-8 px-4 py-12 sm:space-y-8 space-y-6 print:my-0 print:py-4">
            <h1
              className="font-medium sm:text-4
              xl text-3xl text-black text-opacity-60 text-center"
            >
              ORDER#{data?.data?.order?.id ?? ""}
            </h1>

            <div className="flex items-center sm:gap-x-[33%] gap-x-[20%]">
              <div>
                <img
                  src="images/myOrders/qr.webp"
                  className="md:w-40 sm:w-28 w-20"
                  alt=""
                />
              </div>
              <div className="-translate-x-[20%]">
                <img
                  src="images/logo2.webp"
                  className="md:w-56 sm:w-40 w-32"
                  alt=""
                />
              </div>
            </div>

            <div id={pack.id}>
              {/* <div
                    className="flex md:flex-row flex-col md:items-center md:justify-between 
                  gap-y-5 overflow-hidden print:flex"
                  > */}
              <div className="flex print:flex overflow-hidden justify-between">
                <div className="space-y-2 print:w-1/2">
                  <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                    Expected Hub Arrival Date :
                    <span className="font-bold text-black">
                      <Moment format="D MMM , YYYY hh:mm a">
                        {data?.data?.order?.expectedHubArrivalDate}
                      </Moment>
                    </span>
                  </p>
                  <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                    Actual Hub Arrival Date:{" "}
                    <span
                      className="relative before:content-[''] before:absolute before:bottom-0 before:left-2 
                        before:w-28 before:h-0.5 before:bg-black"
                    ></span>
                  </p>
                </div>
                <div className="space-y-2 print:w-1/2 print:text-end">
                  <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                    Expected Consol Number:{" "}
                    <span className="font-bold text-black">28-11-2022</span>
                  </p>
                  <p className="font-medium sm:text-base text-sm text-black text-opacity-60 uppercase">
                    WayBill No:{" "}
                    <span
                      className="relative before:content-[''] before:absolute before:bottom-0 before:left-2 
                        before:w-36 before:h-0.5 before:bg-black"
                    >
                      {pack.id}
                    </span>
                  </p>
                </div>
              </div>
              <table className="my-2 w-full [&>thead>tr>th]:text-start border border-black [&>thead>tr>td]:border [&>thead>tr>td]:border-black [&>tbody>tr>td]:border [&>tbody>tr>td]:border-black">
                <thead>
                  <tr>
                    <th>DIMENSIONS</th>
                    <td className={tdStyle}>Length (cm)</td>
                    <td className={tdStyle}>Width (cm)</td>
                    <td className={tdStyle}>Height (cm)</td>
                    <td className={tdStyle}>Weight (kg)</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={tdStyle}>Captured</td>
                    <td className={tdStyle}>{Number(pack.captureLength)}</td>
                    <td className={tdStyle}>{Number(pack.captureWidth)}</td>
                    <td className={tdStyle}>{Number(pack.captureHeight)}</td>
                    <td className={tdStyle}>{Number(pack.captureWeight)}</td>
                  </tr>
                  <tr>
                    <td className={tdStyle}>Measured</td>
                    <td className={tdStyle}>{Number(pack.measuredLength)}</td>
                    <td className={tdStyle}>{Number(pack.measuredWidth)}</td>
                    <td className={tdStyle}>{Number(pack.measuredHeight)}</td>
                    <td className={tdStyle}>{Number(pack.measuredWeight)}</td>
                  </tr>
                </tbody>
              </table>
              <h1 className="font-normal sm:text-2xl text-lg text-themeRed text-center uppercase print:my-2 mt-2 mb-3">
                Packages without a waybill attached will not be accepted
              </h1>
              <div className="mb-3">
                <h1 className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 px-5 py-2">
                  Send Packages to below address
                </h1>
                <div
                  className="print:flex print:justify-between flex justify-between 
                    px-5 py-3 border border-black gap-y-5"
                >
                  <div>
                    <ul className="[&>li]:font-normal [&>li]:text-base sm:space-y-3 space-y-1 ">
                      <li>{data?.data?.english_address?.address ?? ""}</li>
                      <li>{data?.data?.english_address?.city ?? ""}</li>
                      <li>{data?.data?.english_address?.state ?? ""}</li>
                      <li>{data?.data?.english_address?.zipCode ?? ""}</li>
                      <li>{data?.data?.english_address?.country ?? ""}</li>
                    </ul>
                  </div>
                  <div>
                    <ul className="[&>li]:font-normal [&>li]:text-base sm:space-y-3 space-y-1 ">
                      <li>{data?.data?.china_address?.address ?? ""}</li>
                      <li>{data?.data?.china_address?.city ?? ""}</li>
                      <li>{data?.data?.china_address?.state ?? ""}</li>
                      <li>{data?.data?.china_address?.zipCode ?? ""}</li>
                      <li>{data?.data?.china_address?.country ?? ""}</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-x-5 sm:gap-y-8 gap-y-6 print:flex print:gap-x-5 mb-3">
                <div className="print:w-1/2">
                  <h1
                    className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3
                      px-3 py-2 border border-black "
                  >
                    Supplier Details
                  </h1>
                  <div className="flex">
                    <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm">
                      <li className={liStyle}>Tracking No</li>
                      <li className={liStyle}>Name</li>
                      <li className={liStyle}>Email</li>
                      <li className={liStyle}>Number</li>
                    </ul>
                    <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm w-full">
                      <li className={liStyle}>
                        {data?.data?.order?.SupplierDetail?.trackingNo}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.SupplierDetail?.contactName}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.SupplierDetail?.email}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.SupplierDetail?.phone}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="print:w-1/2">
                  <h1
                    className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 
                      px-3 py-2 border border-black "
                  >
                    Consignee Details
                  </h1>
                  <div className="flex">
                    <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm">
                      <li className={liStyle}>Company</li>
                      <li className={liStyle}>Name</li>
                      <li className={liStyle}>Email</li>
                      <li className={liStyle}>Number</li>
                    </ul>
                    <ul className="[&>li]:font-normal [&>li]:sm:text-base [&>li]:text-sm w-full">
                      <li className={liStyle}>
                        {data?.data?.order?.ConsigneeDetail?.companyName}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.ConsigneeDetail?.contactName}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.ConsigneeDetail?.email}
                      </li>
                      <li className={liStyle}>
                        {data?.data?.order?.ConsigneeDetail?.phone}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div>
                <h1
                  className="font-normal sm:text-xl text-lg uppercase text-white bg-themeGray3 px-3 py-2  
                    border border-black "
                >
                  Destination Details
                </h1>
                <div className="flex">
                  <ul>
                    <li className={liStyle}>Company</li>
                    <li className={liStyle}>Address</li>

                    <li className={liStyle}>Postal Code</li>
                    <li className={liStyle}>City</li>
                    <li className={liStyle}>Province</li>
                    <li className={liStyle}>Country</li>
                  </ul>
                  <ul className="w-full">
                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.companyName}
                    </li>
                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.address}
                    </li>

                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.postalCode}
                    </li>
                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.city}
                    </li>
                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.province}
                    </li>
                    <li className={liStyle}>
                      {data?.data?.order?.DestinationDetail?.country}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
